import __request__ from "routing/request";
export function backendConnection(JSONbody) {
  return __request__("POST", "/system/authentication/services/test/backend/connection", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function backendLogin(JSONbody) {
  return __request__("POST", "/system/authentication/services/test/backend/login", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
